import React from 'react';
import Button from './Button';

const QuickActionToolbar = ({ actions = [], position = 'fixed' }) => {
  if (actions?.length === 0) return null;

  const positionClasses = position === 'fixed' ?'fixed bottom-6 right-6 z-50' :'relative';

  return (
    <div className={`${positionClasses} flex flex-col gap-2`}>
      {actions?.map((action, index) => (
        <Button
          key={index}
          variant={action?.variant || 'default'}
          size={action?.size || 'default'}
          iconName={action?.icon}
          iconPosition="left"
          onClick={action?.onClick}
          disabled={action?.disabled}
          className={`shadow-lg hover:shadow-xl transition-smooth ${action?.className || ''}`}
        >
          {action?.label}
          {action?.badge && (
            <span className="ml-2 px-2 py-0.5 bg-accent text-accent-foreground text-xs font-semibold rounded-full">
              {action?.badge}
            </span>
          )}
        </Button>
      ))}
    </div>
  );
};

export default QuickActionToolbar;